import { Component, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { BrandsList } from '../../models/brands.model'
import { ActivatedRoute, Router } from '@angular/router'
import { AddEditBrandComponent } from '../../components/add-edit-brand/add-edit-brand.component'
import { MatDialog } from '@angular/material/dialog'
import { SharedService } from 'src/app/shared/services/shared.service'
import { StoreService } from '../../services/store.service'

@Component({
	selector: 'app-brands-list',
	templateUrl: './brands-list.component.html',
	styleUrls: ['./brands-list.component.scss'],
})
export class BrandsListComponent implements OnInit {
	subscription = new Subscription()
	brandsFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		searchText: '',
	}
	filterCount = 0
	brands: BrandsList[] = []
	totalCount = 0
	constructor(
		private router: Router,
		private dialog: MatDialog,
		private SharedService: SharedService,
		private ActivatedRoute: ActivatedRoute,
		private brandService: StoreService
	) {
		this.SharedService.headerTitle.next(`STORE.BRANDS_LIST.PAGE_TITLE`)
	}

	ngOnInit(): void {
		this.subscription.add(
			this.ActivatedRoute.queryParams.subscribe((res) => {
				this.brandsFilter.paging.pageNumber = res['page'] || 1
				this.brandsFilter.paging.pageSize = res['count'] || 10
				this.SharedService.handleBreadCrumb('brands', true, {
					name: '',
					id: '',
					url: '/layout/store/brands',
					queryParams: { ...res },
				})
				this.getBrands()
			})
		)
	}

	getBrands(search = false) {
		search ? (this.brandsFilter.paging.pageNumber = 1) : null
		this.subscription.add(
			this.brandService.getBrands(this.brandsFilter).subscribe((res: any) => {
				this.brands = res.result.items
				this.totalCount = res.result.totalCount
			})
		)
	}
	addBrand() {
		this.dialog
			.open(AddEditBrandComponent, {
				width: '585px',
				data: {
					typeTitle: 'brand',
					title: 'ACTIONS.ADD_BRAND',
					label: 'STORE.BRANDS_LIST.ENGLISH_NAME',
					label2: 'STORE.BRANDS_LIST.ARABIC_NAME',
					confirmBtn: 'ACTIONS.ADD',
					cancelBtn: 'ACTIONS.CANCEL',
					hasImg: true,
					type: 'add',
				},
				autoFocus: false,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						let data = {
							name: {
								en: res.f1,
								ar: res.f2,
							},
							imageUrl: res.f3,
							isActive: true,
						}
						this.subscription.add(
							this.brandService.addBrand(data).subscribe((res) => {
								this.getBrands()
							})
						)
					}
				},
			})
	}

	deleteBrand(id: any) {
		this.subscription.add(
			this.brandService.deleteBrand(id).subscribe((res) => {
				this.getBrands()
			})
		)
	}

	updateBrandStatus(brand: any) {
		let requestBody = {
			id: brand.id,
			isActive: !brand.isActive,
		}
		this.subscription.add(
			this.brandService
				.ChangeBrandActivationStatus(requestBody.id, requestBody.isActive)
				.subscribe((res) => {
					this.getBrands()
				})
		)
	}

	pagingChanged(pageNumber: number, pagecount: number) {
		this.router.navigate(['/layout/store/brands'], {
			queryParams: {
				page: pageNumber,
				count: pagecount,
			},
		})
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
